var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaterBottleIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Water_Bottle_icon_svg__clip0_1_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.119 890.976H424.881c-45.072 0-81.953-36.881-81.953-81.952V384.31a87.449 87.449 0 0124.489-60.703l129.654-134.583L631.44 323.393a87.515 87.515 0 0125.631 61.869v423.762c0 45.071-36.881 81.952-81.952 81.952z",
    fill: "#FFF0BF",
    stroke: "#ED1A3C",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.119 890.976H424.881c-45.072 0-81.953-36.881-81.953-81.952V384.31a87.449 87.449 0 0124.489-60.703l129.654-134.583L631.44 323.393a87.515 87.515 0 0125.631 61.869v423.762c0 45.071-36.881 81.952-81.952 81.952z",
    fill: "#fff",
    stroke: "#CAE0E3",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.607 299.595H442.619l-48.19 50.024c-9.024 9.369-13.989 21.679-13.989 34.69v424.715c0 24.512 19.941 44.452 44.453 44.452h150.238c24.512 0 44.452-19.94 44.452-44.452V385.262c0-13.357-5.202-25.917-14.643-35.357l-50.309-50.322-.024.012z",
    fill: "#CAE0E3",
    stroke: "#40C8D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.417 438.345v207.822c-91.845 26.345-185.012 26.345-276.845 0V438.345c91.833 26.345 185 26.345 276.845 0z",
    fill: "#40A9D6",
    stroke: "#4084D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.69 288.869h-75.381c-12.143 0-21.988 9.844-21.988 21.988v2.191c0 12.143 9.845 21.988 21.988 21.988h75.381c12.144 0 21.988-9.845 21.988-21.988v-2.191c0-12.144-9.844-21.988-21.988-21.988z",
    fill: "#CAE0E3",
    stroke: "#40C8D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.095 789.25c-5.524-9.488-15.809-15.905-27.524-15.905H445.429c-11.715 0-22 6.417-27.524 15.905",
    fill: "#CAE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.095 789.25c-5.524-9.488-15.809-15.905-27.524-15.905H445.429c-11.715 0-22 6.417-27.524 15.905",
    stroke: "#40C8D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.679 269.024h-83.346c-25.011 0-45.464-20.465-45.464-45.465v-69.071h174.286v69.071c0 25.012-20.464 45.465-45.464 45.465h-.012z",
    fill: "#4084D6",
    stroke: "#2935D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 576.893c0 22.095-17.905 40-40 40s-40-17.905-40-40 40-72 40-72 40 49.905 40 72z",
    fill: "#CAE0E3",
    stroke: "#40C8D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 169.024h-60v100h60v-100z",
    fill: "#4084D6",
    stroke: "#2935D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.679 199.952h-83.346c-25.011 0-45.464-20.464-45.464-45.464 0-25.012 20.464-45.464 45.464-45.464h83.346c25.012 0 45.464 20.464 45.464 45.464 0 25.012-20.464 45.464-45.464 45.464z",
    fill: "#40A9D6",
    stroke: "#4084D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.143 154.488c0 25.012-20.464 45.464-45.464 45.464h-83.346c-25.011 0-45.464-20.464-45.464-45.464",
    stroke: "#40C8D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Water_Bottle_icon_svg__clip0_1_42"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBottleIcon);
export default ForwardRef;